import PropTypes from 'prop-types';
import React from 'react';

import Panel from 'components/Accordion/Panel/Panel';

const Accordion = (props) => {
  const renderTextPanels = () => {
    return (
      props.items.map((panel, index) => {
        const showState = (props.itemsVisibility && props.itemsVisibility[index]) ? props.itemsVisibility[index].show : false;

        return (
          <Panel
            content={panel.content}
            id={index}
            key={index}
            show={showState}
            title={panel.title}
            toggle={props.toggle}
            type={props.contentKey}
          />
        );
      })
    );
  };

  return (
    <ul>
      {renderTextPanels()}
    </ul>
  );
};

Accordion.propTypes = {
  contentKey: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  itemsVisibility: PropTypes.object,
  toggle: PropTypes.func.isRequired,
};

export default Accordion;
